import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative pt-28 pb-12 md:pt-32 md:pb-16 overflow-hidden" data-id="element-87">
      {/* Abstract Background Elements */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-amber/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-88" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-navy-lighter rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none" data-id="element-89" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-90">
        <div className="max-w-4xl" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-92">
            <span className="inline-block py-1 px-3 rounded-full border border-amber/30 text-amber text-xs font-medium tracking-wider uppercase mb-6" data-id="element-93">
              Executive Advisory
            </span>
          </motion.div>

          <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif leading-[1.1] mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1,
          ease: 'easeOut'
        }} data-id="element-94">
            We help organizations <br className="hidden md:block" data-id="element-95" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber to-amber-hover" data-id="element-96">
              think
            </span>{' '}
            together, better.
          </motion.h1>

          <motion.p className="text-lg md:text-xl text-offwhite-muted max-w-2xl mb-12 font-light leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-97">
            Cognisensus is a strategic consulting practice that aligns
            leadership teams, facilitating organizational changes, post-merger
            integration, and machine intelligence workflows.
          </motion.p>

          <motion.div className="flex flex-col sm:flex-row gap-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3,
          ease: 'easeOut'
        }} data-id="element-98">
            <Link to="/domain-focus" className="group flex items-center justify-center gap-2 px-8 py-4 bg-amber text-navy font-medium rounded-sm hover:bg-amber-hover transition-all" data-id="element-99">
              Executive Workshops
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-100" />
            </Link>
            <a href="mailto:matt@mattdadvisory.com" className="px-8 py-4 bg-transparent border border-white/20 text-offwhite font-medium rounded-sm hover:bg-white/5 transition-all text-center" data-id="element-101">
              Contact Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}